import useQueryParams from '@hooks/use-query-params';

import { FilterHeader } from 'components/headers';
import { TabList, Tab, useTabState } from 'components/Tabs';
import { useStore } from 'models/Provider';

import { useOnboardingContext, useOnboardingFilterState } from './onboarding-config';

export const OnboardingHeader: React.FC = (props) => {
  const { t } = useStore();
  const { filters } = useOnboardingContext();
  const filterState = useOnboardingFilterState();

  return (
    <FilterHeader
      title={t('navigation.onboarding')}
      filters={filters}
      filterState={filterState}
      searchPlaceholder={t('applicants.header.search.placeholder')}
      tabs={<OnboardingTabs />}
      {...props}
    />
  );
};

const OnboardingTabs = () => {
  const { t } = useStore();
  const section = useQueryParams('section');
  const selectedId = section === 'completed' ? 1 : 0;
  const tabState = useTabState({ selectedId });

  return (
    // @ts-ignore TabList is untyped
    <TabList state={tabState} label="Onboarding status selection">
      {/* @ts-ignore Tablist is untyped */}
      <Tab link="/onboarding">{t('onboarding.tabs.in_progress')}</Tab>
      {/* @ts-ignore Tablist is untyped */}
      <Tab link="/onboarding?section=completed">{t('onboarding.tabs.completed')}</Tab>
    </TabList>
  );
};
